import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DataConnectService } from 'src/app/services/data-connect.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ConfirmDialogService } from 'src/app/services/confirm-dialog.service';
import { AngularEditorConfig } from '@kolkov/angular-editor';
import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'app-asignar',
  templateUrl: './asignar.component.html',
  styleUrls: ['./asignar.component.css']
})
export class AsignarComponent implements OnInit {
  id: number;
  reparticiones: any =[];
  seleccionados: any = [];
  formValidators = {
    'para': [
      { type: 'required', message: 'Seleccione destinatario para asignación' }
    ],
    'correocopia': [
      { type: 'pattern', message: 'El Correo es Inválido' }
    ],
    'mensaje': [
      { type: 'required', message: 'Ingrese su Mensaje' },
      { type: 'minLength', message: 'Debe Tener un Largo Mayor a 1 caracter' },
      { type: 'maxLength', message: 'Debe ser Menos a 5000 Caracteres' },
    ],
  }
  oirsasgina: FormGroup;
  correocopiaaux =[];
  editorConfig: AngularEditorConfig = {
    
    editable: true,
      spellcheck: false,
      height: 'auto',
      minHeight: '400px',
      maxHeight: 'auto',
      width: 'auto',
      minWidth: '600px',
      translate: 'yes',
      enableToolbar: true,
      showToolbar: true,
      placeholder: 'Ingrese Mensaje',
      defaultParagraphSeparator: '',
      defaultFontName: '',
      defaultFontSize: '',
      fonts: [
        {class: 'arial', name: 'Arial'},
        {class: 'times-new-roman', name: 'Times New Roman'},
        {class: 'calibri', name: 'Calibri'},
        {class: 'comic-sans-ms', name: 'Comic Sans MS'}
      ],
      customClasses: [
      {
        name: 'quote',
        class: 'quote',
      },
      {
        name: 'redText',
        class: 'redText'
      },
      {
        name: 'titleText',
        class: 'titleText',
        tag: 'h1',
      },
    ],
    //uploadUrl: 'v1/image',
    sanitize: true,
    toolbarPosition: 'top',
    toolbarHiddenButtons: [
      ['bold', 'italic'],
      ['fontSize']
    ]
};
  datos: any;
  get f(): any { return this.oirsasgina.controls; }
  constructor( private router: Router,private route: ActivatedRoute, private _service: DataConnectService, private confirmdialogservice: ConfirmDialogService, private auth: AuthService) {
    if(this._service.lista == undefined){
      this.router.navigate(['/inicio']);
    }
   }

  ngOnInit() {
    this.route.params.subscribe(params => {
      this.id = +params['IDSolicitud']; // (+) converts string 'id' to a number
      
   });
   this.busquedasolicitud(this.id)
   this.BReparticionAsignar()
    this.oirsasgina = new FormGroup({
      para: new FormControl([], Validators.required),//seleccion lista para
      correocopia: new FormControl('', [ Validators.pattern('^([a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+[.]+[a-zA-Z0-9-.]{2,4})+$')]),//carnet o pasaporte
      mensaje: new FormControl('', [Validators.required, Validators.minLength(1), Validators.maxLength(5000)]),//carnet o pasaporte
      cc: new FormControl([]),//seleccion lista para
      respuestadirecta: new FormControl(false)
    });
    
    //this.datos = this._service.lista.filter(d => d.IDSolicitud == this.id);

   
  //   this.route.params.subscribe(params => {

  //     this.id = +params['IDSolicitud']; // (+) converts string 'id' to a number
  //  });
  }
  
  busquedasolicitud(id){
    return this._service.ver(id, 1034).subscribe(
      res =>{
        console.log(res)
        this.datos = res.solicitud[0];
      }
    )
  }
  BReparticionAsignar(){
    return this._service.BReparticionAsignar().subscribe(
      res => {
        console.log(res)
        this.reparticiones = res;
      }
    )
  }
  pushpop(index){
    
    if(this.seleccionados.length >= 1){
      this.oirsasgina.controls['respuestadirecta'].setValue(false);
    }
    
    this.seleccionados.push(this.reparticiones[index])
    this.reparticiones.splice(index,1)
    this.oirsasgina.controls['para'].setValue(this.seleccionados)
  }
  poppush(index){
    
    if(this.seleccionados.length >= 1){
      this.oirsasgina.controls['respuestadirecta'].setValue(false);
    }
    this.reparticiones.push(this.seleccionados[index])
    this.seleccionados.splice(index,1)
    this.oirsasgina.controls['para'].setValue(this.seleccionados)
    
  }
  agregar(a){

    this.correocopiaaux.push(a)
    this.oirsasgina.controls['correocopia'].setValue('')
    this.oirsasgina.controls['cc'].setValue(this.correocopiaaux)
  }
  eliminarcc(index){

    this.correocopiaaux.splice(index,1)
    this.oirsasgina.controls['cc'].setValue(this.correocopiaaux)
  }
  onSubmit(){
    //console.log(this.id,  this.auth.datosusuario.data.rut, this.oirsasgina.value, this.datos)
    this.confirmdialogservice.confirm('Confirmar', '¿Está Seguro que Desea Guardar y Enviar su Requerimiento?',true)
    
    .then((confirmed) => {
      
      if(confirmed){
        this._service.IoirsAsignacion(this.id,  this.auth.datosusuario.data.rut, this.oirsasgina.value, this.datos).subscribe(
          (resp) => {

            // this.cambioTpDocumento(1)
            if(resp != undefined){
             this.confirmdialogservice.confirm('Error en Ingreso de Solicitud',
             'Ocurrió un Error al Momento de Ingresar su Solicitud, Sí El Problema Persiste por Favor Contacte con mesadeayuda@directemar.cl',false).then((confirmed) => {
              if (confirmed) {

                //this.reset()
                }
              }).catch(() => this.router.navigate(['/inicio']));
            } else {
            this.confirmdialogservice.confirm('Asignación de Solicitud',
            'Solicitud Asignada Correctamente',false).then((confirmed) => {
             if (confirmed) {

               this.router.navigate(['/inicio']);
               }
             }).catch(() => this.router.navigate(['/inicio']));
           }


            
           }
        )

        // this.confirmdialogservice.confirm('Asignación de solicitud',
        // 'Solicitud Asignada Correctamente',false).then((confirmed) => {
        //  if (confirmed) {

        //   this.router.navigate(['/inicio']);
        //    }
        //  }).catch(() => this.router.navigate(['/inicio']));



       
      
      
      }
    }
    )
    .catch(() => console.log('User dismissed the dialog (e.g., by using ESC, clicking the cross icon, or clicking outside the dialog)'));


   



  }
    
  
}
